import React, { useState } from "react";
import "./TopFreeNavigation2.scss";

interface FlowItem {
  id: number | string;
  name: string;
  url?: string;
  childs?: FlowItem[];
}

interface Props {
  tree: FlowItem[];
  onItemClick?: (item: FlowItem) => void;
}

const TopFreeNavigation2: React.FC<Props> = ({
  tree,
  onItemClick,
}) => {
  const [hoveredMain, setHoveredMain] = useState<number | null>(null);
  const [hoveredChild, setHoveredChild] = useState<string | number | null>(null);
  const [activeMain, setActiveMain] = useState<number | null>(0);
  const [activeChild, setActiveChild] = useState<string | number | null>(null);
  const [activeGrand, setActiveGrand] = useState<string | number | null>(null);
  const [hasInteracted, setHasInteracted] = useState<boolean>(false);

  const handleMainClick = (item: FlowItem, index: number) => {
    setActiveMain(index);
    setActiveChild(null);
    setActiveGrand(null);
    setHasInteracted(true);
    onItemClick?.(item);
  };

  const handleChildClick = (child: FlowItem, parentIndex: number) => {
    setActiveMain(parentIndex);
    setActiveChild(child.id);
    setActiveGrand(null);
    setHasInteracted(true);
    onItemClick?.(child);
  };

  const handleGrandClick = (
    grand: FlowItem,
    parentIndex: number,
    childId: string | number
  ) => {
    setActiveMain(parentIndex);
    setActiveChild(childId);
    setActiveGrand(grand.id);
    setHasInteracted(true);
    onItemClick?.(grand);
  };

  return (
    <div className="tpf2-wrapper">
      {tree.map((item, index) => {
        const hasChilds = item.childs && item.childs.length > 0;
        const isActiveMain = activeMain === index;

        return (
          <div
            key={item.id}
            className={`tpf2-step ${isActiveMain ? "active" : ""}`}
            onClick={(e) =>{ 
              e.preventDefault();
              handleMainClick(item, index)
            }}
          >
            <div
              className="tpf2-hover-zone"
              onMouseEnter={() => setHoveredMain(index)}
              onMouseLeave={() => {
                setHoveredMain(null);
                setHoveredChild(null);
              }}
            >
              <div className="tpf2-step-main">
                <div
                  className={`tpf2-step-label ${
                    isActiveMain ? "active" : ""
                  }`}
                >

                  {item.name}

                  {isActiveMain && (
                    <span className="tpf2-you-are-here">
                      {hasInteracted ? "You are here" : "Start here"}
                    </span>
                  )}
                  
                </div>
              </div>

              {hasChilds && (
                <div
                  className={`tpf2-underline ${
                    isActiveMain ? "active" : ""
                  }`}
                >
                  <div className="tpf2-underline-line" />
                  <div className="tpf2-underline-arrow">▾</div>
                </div>
              )}

              {hasChilds && hoveredMain === index && (
                <div className="tpf2-dropdown">
                  {item.childs!.map((child) => {
                    const hasGrand =
                      child.childs && child.childs.length > 0;
                    const isActiveChild =
                      activeChild === child.id;

                    return (
                      <div
                        key={child.id}
                        className={`tpf2-dropdown-item tpf2-dropdown-item-main ${
                          isActiveChild ? "active" : ""
                        }`}
                        onMouseEnter={() =>
                          setHoveredChild(child.id)
                        }
                        onMouseLeave={() =>
                          setHoveredChild(null)
                        }
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          handleChildClick(child, index);
                        }}
                      >
                        {child.name}

                        {hasGrand && (
                          <span className="tpf2-arrow-right">
                            ▶
                          </span>
                        )}

                        {hasGrand &&
                          hoveredChild === child.id && (
                            <div className="tpf2-dropdown-right">
                              {child.childs!.map((grand) => {
                                const isActiveGrand =
                                  activeGrand === grand.id;

                                return (
                                  <div
                                    key={grand.id}
                                    className={`tpf2-dropdown-item ${
                                      isActiveGrand
                                        ? "active"
                                        : ""
                                    }`}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      e.preventDefault();
                                      handleGrandClick(
                                        grand,
                                        index,
                                        child.id
                                      );
                                    }}
                                  >
                                    {grand.name}
                                  </div>
                                );
                              })}
                            </div>
                          )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TopFreeNavigation2;
